export default () => ({
  trigger: {
    name: 'chatbot.end_live_chat',
    params: {},
  },
  config: {
    event: {
      name: 'end_feature',
      params: {
        sub_feature: 'live_chat',
        item_ids: null,
      },
    },
  },
});
